import * as React from 'react';
import {Select} from "antd";
import {FeatureFilter, getMaintenanceSheetFilterOptions} from "../common/FeatureFilter";

interface State {
  value: FeatureFilter
}

interface Props {
  value?: FeatureFilter;
  onChange: (value: FeatureFilter) => void;
}

export default class MaintenanceSheetFilterSelector extends React.Component<Props, State> {

  public state: State = {
    value: this.props.value ? this.props.value : FeatureFilter.ALL
  };

  public render(): React.ReactElement {
    const {value} = this.state;

    const onChange = (filter: FeatureFilter) => {
      this.props.onChange(filter);
      this.setState({
        value: filter
      });
    };
    return (
      <Select size="small" style={{width: 250}} value={value} onChange={onChange}>
        {getMaintenanceSheetFilterOptions()}
      </Select>
    );
  }
}


// WEBPACK FOOTER //
// ./src/item/MaintenanceSheetFilterSelector.tsx